import { AppointmentCancelCommand, AppointmentInvalidTransitionFault } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor, dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { translationKeys } from '../translations';

type AppointmentCancelActionEventInterceptorProps = Readonly<{
   appointmentId: number;
   children: JSX.Element;
   onFault: VoidFunction;
   onSuccess: VoidFunction;
}>;

export const AppointmentCancelActionEventInterceptor = (
   props: AppointmentCancelActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: cancelAppointment } = useCqrsCommand<void, void, AppointmentInvalidTransitionFault>(
      () => {
         const command = new AppointmentCancelCommand();
         command.id = AppointmentId.of(props.appointmentId);
         return command;
      },
      {
         onSuccess: props.onSuccess,
         onFault: {
            'egabinet-appointment-frontend-api:AppointmentInvalidTransitionFault': () => {
               dispatchSnackbarNegativeEvent(translationKeys.visitAlreadyCancelled);
               props.onFault();
            },
         },
      }
   );

   return <ActionEventInterceptor action={cancelAppointment}>{props.children}</ActionEventInterceptor>;
};
